var general_rtlignore_default = {
  "alignLeft": "IY14G",
  "textWrapNowrap": "LnTnd",
  "alignRight": "Ca7f4",
  "alignCenter": "_3R35u",
  "sizeFullWidth": "Ml0pD",
  "renderedInTable": "G4O60",
  "sizeOriginal": "hiGsv",
  "sizeContent": "oO7vd",
  "sizeSmall": "atLOR",
  "sizeSmallCenter": "_1c6RH",
  "flex": "EwwaP"
};
export {
  general_rtlignore_default as default
};
//# sourceMappingURL=general.rtlignore-scss.js.map
